module.exports = __webpack_public_path__ + "static/media/intro-3@2x.fa323f0d.jpg";